// Input validation rules mirrored from the Rust `chorepop-core` crate.
//
// The server-side Rust validation is always authoritative — the frontend
// version exists so we can give users immediate feedback without a
// round-trip. Any discrepancy between the two is a bug; fix the Rust
// version first, then this one.

export const MIN_PASSWORD_LENGTH = 10;

export type PasswordValidationError = {
  code: 'password_too_short';
  min: number;
  actual: number;
  message: string;
};

export function validatePasswordLength(password: string): PasswordValidationError | null {
  // Count characters (code points), not bytes, to match Rust's char_indices
  // behaviour. Array.from splits into code points.
  const actual = Array.from(password).length;
  if (actual < MIN_PASSWORD_LENGTH) {
    return {
      code: 'password_too_short',
      min: MIN_PASSWORD_LENGTH,
      actual,
      message: `Password must be at least ${MIN_PASSWORD_LENGTH} characters (was ${actual}).`,
    };
  }
  return null;
}
